module.exports = __webpack_public_path__ + "img/sort-az-red.e2d4c398.svg";